import { render, staticRenderFns } from "./effectAnalysis.vue?vue&type=template&id=36f38fdd&scoped=true"
import script from "./effectAnalysis.vue?vue&type=script&lang=js"
export * from "./effectAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f38fdd",
  null
  
)

export default component.exports